import {ValueObject} from '@s-ui/domain'

export class VehicleCertificationValueObject extends ValueObject {
  /**
   * @param {Number} certificatedProgramId
   * @param {Array<CertificationFeaturesListValueObject>} features
   * @param {String} logoUrl
   * @param {String} make
   * */
}
